import {ProjectModel, projectModelFactory} from "./project.model";
import {PercentageBarModel, percentageBarModelFactory} from "../misc/percentage-bar.model";
import {UserModel, userModelListFactory} from "../types/user.model";

export interface ProjectDetailModel extends ProjectModel {
  deployedToK2PercentageBar?: PercentageBarModel;
  pastSchedule?: boolean;
  pastScheduleMessage?: string;
  overBudget?: boolean;
  overBudgetMessage?: string;
  transitionLeads?: UserModel[];
  accountLeads?: UserModel[];
  pursuitLead?: UserModel[];
  discoveryDesignLead?: UserModel[];
  contractAdministrator?: UserModel[];
  productSupportSpecialist?: UserModel[];
  siteCount?: number;
  deploymentCount?: number;
  orderCount?: number;
  plannedDevices?: number;
  orderedDevices?: number;
  deployedDevices?: number;
  totalDevices?: number;
  countryName?: string;
  geoRegionId?: string;
  rejected?: boolean;
  rejectedReason?: string;
  rejectedDate?: string;
  allowUnRejectProject?: boolean;
  iAmTheLastOne?: boolean;
  geo_region_id?: string;
  allowSetGeoRegion: boolean;
}

export type ProjectDetailListResponse = {rows: ProjectDetailModel[], count: number};

export function projectDetailModelFactory(json?: any): ProjectDetailModel {
  json = json || {};

  const project = projectModelFactory(json);

  return {
    ...project,
    deployedToK2PercentageBar: percentageBarModelFactory(json.deployedToK2PercentageBar),
    pastSchedule: !!json.pastSchedule,
    pastScheduleMessage: json.pastScheduleMessage || "",
    overBudget: !!json.overBudget,
    overBudgetMessage: json.overBudgetMessage || "",
    transitionLeads: userModelListFactory(json.transitionLeads),
    accountLeads: userModelListFactory(json.accountLeads),
    pursuitLead: userModelListFactory(json.pursuitLead),
    discoveryDesignLead: userModelListFactory(json.discoveryDesignLead),
    contractAdministrator: userModelListFactory(json.contractAdministrator),
    productSupportSpecialist: userModelListFactory(json.productSupportSpecialist),
    siteCount: +json.siteCount || 0,
    deploymentCount: +json.deploymentCount || 0,
    orderCount: +json.orderCount || 0,
    plannedDevices: +json.plannedDevices || 0,
    orderedDevices: +json.orderedDevices || 0,
    deployedDevices: +json.deployedDevices || 0,
    totalDevices: +json.totalDevices || 0,
    countryName: json.countryName || "",
    geoRegionId: json.geoRegionId || "",
    rejected: !!json.rejected,
    rejectedReason: json.rejectedReason || "",
    rejectedDate: json.rejectedDate || "",
    allowUnRejectProject: !!json.allowUnRejectProject,
    iAmTheLastOne: !!json.iAmTheLastOne,
    geo_region_id: json.geo_region_id || "", // eslint-disable-line @typescript-eslint/camelcase
    allowSetGeoRegion: !!json.allowSetGeoRegion,
  } as ProjectDetailModel;
}

export function projectDetailModelListFactory(json?: any): ProjectDetailModel[] {
  return Array.from(json || []).map(project => projectDetailModelFactory(project));
}

export function projectDetailListResponseFactory(json?: any): ProjectDetailListResponse {
  json = json || {};
  return {rows: projectDetailModelListFactory(json.rows), count: +json.count} as ProjectDetailListResponse;
}
